import type { FeatureFlags } from "@shared/types";
import { AxiosRequestConfig } from "axios";
import { axios } from ".";

const FEATURE_FLAGS_URL = "/api/v1/services/bc-services/config/feature-flags";

export const getFeatureFlags = async (vendorRegion: string, countryCode?: string): Promise<FeatureFlags> => {
  const config: AxiosRequestConfig = { params: { vendorRegion, ...(countryCode && { countryCode }) } };
  const response = await axios.get<{ data: FeatureFlags }>(FEATURE_FLAGS_URL, config);
  return response.data.data;
};
